class ChangeProductCommand {
  constructor(prevProduct, product, controller) {
    this.prevProduct = prevProduct;
    this.product = product;
    this.controller = controller;
  }
  execute() {
    this.controller.changeProduct(this.product, true /* silent */)(
      this.controller.dispatch,
      this.controller.getState
    );
  }
  undo() {
    this.controller.changeProduct(this.prevProduct, true /* silent */)(
      this.controller.dispatch,
      this.controller.getState
    );
  }
}

export default ChangeProductCommand;
